module.exports = __webpack_public_path__ + "static/media/success-circled-arrow.d71dd08a.png";